module.exports = __webpack_public_path__ + "img/yyxt.01f15211.png";